export default {
  methods: {
    countTotal(arr, propertyToExtract) {
      const totalArray = [];
      for (let singleDate of arr) {
        totalArray.push(singleDate[2][propertyToExtract]);
      }
      return totalArray.reduce(this.reduceTotal, 0);
    },
    reduceTotal(acc, currentValue) {
      if (currentValue !== undefined) {
        return acc + currentValue;
      }
      return acc;
    },
  },
};
